import React, { useEffect, useRef, useState } from "react";
import "./style.scss";
import { useStores } from "../../stores";
import NoImage from "../../assets/images/noImage.jpg";
import FNBListView from "../../components/FNBListView";
import Header from "../../components/Header";
import notify from "../../components/Notify/notify";
import ValidateEmail from "../../components/Helper/emailValidate";
import { useLocation, useNavigate } from "react-router-dom";

const Payment = () => {
  const { bookingStore } = useStores();
  const location = useLocation();
  let stateData = {}
  if (location?.state?.screen) {
    stateData = { item: location?.state?.item, inventoryId: location?.state?.inventoryId, selectedItems: location?.state?.selectedItems, screen: location?.state?.screen, selectedFnb: location?.state?.selectedFnb, flag: location?.state?.flag };
  }
  const coupon_ref = useRef();
  const navigate = useNavigate();
  const [FNBList, setFNBList] = useState([]);
  const [FNBListNew, setFNBListNew] = useState([]);
  const [couponDiscount, setInventoryPrice] = useState([]);
  const [selectedSpaceItem, setSelectedSpaceItem] = useState([]);
  const [selectedInvItem, setSelectInvItem] = useState([]);
  const selectSpaceItem = sessionStorage.getItem("selectSpaceItem");
  const selectInverntoryItem = sessionStorage.getItem("selectInverntoryItem");
  const selectedDate = sessionStorage.getItem("selectedDate");
  const selectSlotItem = sessionStorage.getItem("selectSlotItem");
  let parseDate = JSON.parse(selectedDate);
  const [capacity, setCapacity] = useState('')
  const [invName, setInvName] = useState('')
  const [time, setTime] = useState('')
  const [validStartTime, setValidStartTime] = useState('')
  const [validEndTime, setValidEndTime] = useState('')
  const [applycolor, setaApplycolor] = useState('')
  const [key, setKey] = useState(Math.random());

  const weekday = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  let date = new Date(parseDate).toLocaleString("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
  let day = weekday[new Date(parseDate).getDay()];
  const [selectDate, setSelectDate] = useState(parseDate);

  const [selectDate2, setSelectDate2] = useState(`${day}, ${date}`);
  const [selectSlot, setSelectSlot] = useState([]);
  const [startTime, setStartTime] = useState([]);
  const [endTime, setEndTime] = useState([]);
  const [accessKey, setAccessKey] = useState("");
  const [orderedFnbList, setOrderedFnbList] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [campaign, setCampaign] = useState({});
  const [termsAgree, setTermsAgree] = useState(true);
  const [spaceName, setSpaceName] = useState("");
  const [selectedSpaceItemId, setSelectedSpaceItemId] = useState("");
  const [coupon, setCoupon] = useState("");
  const [applyedCoupon, setApplyedCoupon] = useState("");
  const [couponName, setCouponName] = useState("");
  const [validCoupon, setValidCoupon] = useState(false);
  const [checkAvailability, setCheckAvailability] = useState([]);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [blockHome, setBlockHome] = useState(false);
  const [scrollFlag, setScrollFlag] = useState(true);
  const [campainSpaceId, setCampainSpaceId] = useState("");
  const [spaceAddress, setSpaceAddress] = useState("");
  const [spaceImage, setSpaceImage] = useState("");
  let newvar = window.location.pathname;
  let access_key = newvar.split("/payment/")[1];

  useEffect(() => {
    setScrollFlag(false);
  }, [scrollFlag]);

  useEffect(() => {
    if (stateData?.screen === 'direct') {
      if (stateData?.item !== null) {
        stateData?.item?.inventories?.map((i) => {
          if (i?.id === stateData?.inventoryId) {
            setCapacity(i?.capacity)
            setInvName(i?.name)
            setSpaceImage(JSON.parse(i?.images)[0])
            setSpaceName(stateData?.item.name)
            setSpaceAddress(stateData?.item.address)
          }
        })
      }
      if (stateData?.selectedFnb !== null && stateData?.selectedFnb !== undefined) {
        let price = 0;
        stateData?.selectedFnb.map((item) => {
          price = price + Number(item.price)
        })
        setTotalAmount(price);
        setOrderedFnbList(stateData?.selectedFnb);

      }
    } else {
      if (stateData?.selectedFnb !== null && stateData?.selectedFnb !== undefined) {
        let price = 0;
        stateData?.selectedFnb.map((item) => {
          price = price + Number(item.price)
        })
        setTotalAmount(price);
        setOrderedFnbList(stateData?.selectedFnb);
      }
    }
  }, [])

  useEffect(() => {
    if (stateData?.screen != 'retry') {
      setAccessKey(access_key);
      sessionStorage.setItem("acckey", access_key)
      if (!selectSpaceItem && stateData?.screen !== 'direct' && stateData?.screen !== 'retry') {
        setBlockHome(true);
        getCampaign(access_key);
        sessionStorage.setItem("blockPage", true);
      }
    }
    else {
      let acckey = sessionStorage.getItem("acckey")
      setAccessKey(acckey);
    }
  }, []);

  useEffect(() => {
    getSelectedSpaceItem();
  }, []);

  useEffect(() => {
    getFNBList();
  }, [selectedSpaceItemId]);

  React.useEffect(() => {
    const listener = event => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {

        document.getElementById("submitButton").click();
        event.preventDefault();
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, []);

  const getCampaignDate = (date) => {
    let tempDate = new Date(date).toLocaleString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
    let day = weekday[new Date(tempDate).getDay()];
    setSelectDate2(`${day}, ${tempDate}`)
  };

  const getCheckAvailability = async () => {
    let check = "";
    let parseInvData =
      selectInverntoryItem !== "undefined" &&
      selectInverntoryItem?.length > 0 &&
      JSON.parse(selectInverntoryItem);
    let parsSlotData =
      selectSlotItem !== "undefined" &&
      selectSlotItem?.length > 0 &&
      JSON.parse(selectSlotItem);
    setSelectSlot(parsSlotData);
    let startTime = parsSlotData && [...parsSlotData].shift();
    let endTime = parsSlotData[parsSlotData.length - 1];
    let start = startTime?.start?.split(":")[0];
    let valid_from = `${selectDate}${" "}${start}:00:00`;
    let end = endTime?.end?.split(":")[0];
    let valid_upto = "";

    if (end <= 9) {
      valid_upto = `${selectDate}${" "}${end}:00:00`;
    } else {
      valid_upto = `${selectDate}${" "}${end}:00:00`;
    }

    let valid_from_velidate =
      selectDate != null && selectDate != undefined && selectDate != ""
        ? valid_from
        : campaign?.valid_from;
    let valid_upto_velidate =
      selectDate != null && selectDate != undefined && selectDate != ""
        ? valid_upto
        : campaign?.valid_upto;

    let inventory_id =
      parseInvData.id != null &&
        parseInvData.id != undefined &&
        parseInvData.id != ""
        ? parseInvData.id
        : campaign.inventory_id;
    if (stateData?.screen === 'direct' || stateData?.screen === 'retry') {
      // console.log(selectedItems)
      let startTime = stateData?.selectedItems[0]?.start
      let endTime = stateData?.selectedItems[stateData?.selectedItems.length - 1]?.end;
      let start = startTime?.split(":")[0];
      let valid_from = `${selectDate}${" "}${start}:00:00`;
      let end = endTime?.split(":")[0];
      let valid_upto = `${selectDate}${" "}${end}:00:00`;
      let params = `inventory_id=${stateData?.inventoryId}&valid_from=${valid_from}&valid_upto=${valid_upto}`;
      // console.log('params ', params);
      await bookingStore.getCheckAvailability(params, (response) => {
        if (response?.data?.status === 1) {
          // console.log(response?.data);
          check = response?.data?.data;
          setCheckAvailability(response?.data?.data);
        } else {
          console.log("error");
        }
      });

    } else {
      let params = `inventory_id=${inventory_id}&valid_from=${valid_from_velidate}&valid_upto=${valid_upto_velidate}`;
      await bookingStore.getCheckAvailability(params, (response) => {
        if (response?.data?.status === 1) {
          // console.log(response?.data);
          check = response?.data?.data;
          setCheckAvailability(response?.data?.data);
        } else {
          console.log("error");
        }
      });
    }

    return check;
  };

  const getCampaign = async (key) => {
    let params = `access_key=${key}`;
    await bookingStore.getCampaign(params, (response) => {
      if (response?.data?.status === 1) {
        sessionStorage.setItem(
          "campdata",
          JSON.stringify(response?.data?.data)
        );
        setBlockHome(true);
        setCampaign(response?.data?.data);
        //console.log(JSON.parse(response?.data?.data.images).length);
        setSpaceName(response?.data?.data?.space_name);
        setSelectedSpaceItemId(response?.data?.data?.space_id);
        let date = response?.data?.data?.valid_from?.split(" ")[0];
        if (stateData?.screen !== 'direct' || stateData?.screen !== 'retry') {
          getCampaignDate(date);
        }
        getInventoryPrice("", "", response?.data?.data, "", "");
      } else {
        console.log("error");
      }
    });
  };

  const getSelectedSpaceItem = (check) => {
    if (check) {
      if (coupon === "") {
        notify("Please enter coupon code", "danger");
        return;
      }
    }

    let parseData =
      selectSpaceItem !== "undefined" &&
      selectSpaceItem?.length > 0 &&
      JSON.parse(selectSpaceItem);
    setSelectedSpaceItem(parseData);
    let parseInvData =
      selectInverntoryItem !== "undefined" &&
      selectInverntoryItem?.length > 0 &&
      JSON.parse(selectInverntoryItem);
    setSelectInvItem(parseInvData);
    let parsSlotData =
      selectSlotItem !== "undefined" &&
      selectSlotItem?.length > 0 &&
      JSON.parse(selectSlotItem);
    setSelectSlot(parsSlotData);
    if (parsSlotData.length > 0) {
      let startTime = [...parsSlotData].shift();
      let endTime = parsSlotData[parsSlotData?.length - 1];
      setStartTime(startTime);
      setEndTime(endTime);
    }
    if (stateData?.screen === 'direct' || stateData?.screen === 'retry') {
      setSelectedSpaceItemId(stateData?.item.id)
      getInventoryPrice('', '', '', stateData?.inventoryId, stateData?.selectedItems);
    } else {
      setSelectedSpaceItemId(parseData?.id);
      getInventoryPrice(parseInvData, parsSlotData, "", "", "");
    }

    // console.log("parseData", parseData);
  };

  const getFNBList = async (id) => {
    // let space_id =
    //   selectedSpaceItemId != null &&
    //   // selectedSpaceItemId != undefined ||
    //   selectedSpaceItemId != ""
    //     ? selectedSpaceItemId
    //     : campainSpaceId;

    let paramValue = id
      ? `space_id=${selectedSpaceItemId}&is_veg=${id}`
      : `space_id=${selectedSpaceItemId}`;
    let params = paramValue;
    if (selectedSpaceItemId !== "" && selectedSpaceItemId !== undefined) {
      await bookingStore.getFnbList(params, (response) => {
        if (response?.data?.status === 1) {
          let fnb = response?.data?.data?.data;

          if (stateData?.flag !== undefined) {
            if (stateData?.flag === 'retry') {
              fnb.forEach(element => {
                if (stateData?.selectedFnb !== null) {
                  stateData?.selectedFnb.forEach(item => {
                    if (element.id === item.id) {
                      element.quantity = item.quantity;
                    }
                  });
                }
              });
              setFNBList(fnb);
              setFNBListNew(fnb);
            }
          }
          else {
            setFNBList(fnb);
            setFNBListNew(fnb);
            // console.log(response?.data?.data?.data);
          }
        } else {
          console.log("error");
        }
      });
    }
  };

  const getInventoryPrice = async (parseInvData, parsSlotData, campData, invId, selectedItems) => {
    // console.log("campaign", parseInvData, "=====", parsSlotData, "=====");
    let startTime = parsSlotData && [...parsSlotData].shift();
    let endTime = parsSlotData[parsSlotData.length - 1];
    let start = startTime?.start?.split(":")[0];
    let valid_from = `${selectDate}${" "}${start}:00:00`;
    let end = endTime?.end?.split(":")[0];
    let valid_upto = "";

    if (end <= 9) {
      valid_upto = `${selectDate}${" "}${end}:00:00`;
    } else {
      valid_upto = `${selectDate}${" "}${end}:00:00`;
    }

    let valid_from_velidate =
      selectDate !== null && selectDate !== undefined && selectDate !== ""
        ? valid_from
        : campData?.valid_from;
    let valid_upto_velidate =
      selectDate !== null && selectDate !== undefined && selectDate !== ""
        ? valid_upto
        : campData?.valid_upto;
    let inventory_id =
      parseInvData.id !== null &&
        parseInvData.id !== undefined &&
        parseInvData.id !== ""
        ? parseInvData.id
        : campData?.inventory_id;
    if (stateData?.screen === 'direct' || stateData?.screen === 'retry') {
      let startTime = selectedItems[0]?.start
      let endTime = selectedItems[selectedItems.length - 1]?.end;
      let start = startTime?.split(":")[0];
      let valid_from = `${selectDate}${" "}${start}:00:00`;
      let end = endTime?.split(":")[0];
      let valid_upto = `${selectDate}${" "}${end}:00:00`;
      setValidStartTime(startTime)
      setValidEndTime(endTime)

      let params = `inventory_id=${invId}&duration_type_id=${1}&valid_from=${valid_from}&valid_upto=${valid_upto}&access_key=${access_key}`;
      await bookingStore.inventoryPrice(params, (response) => {
        if (response?.data?.status === 1) {
          setInventoryPrice(response?.data?.data);
        } else {
          console.log("error");
        }
      });
    } else {
      if (
        inventory_id != undefined &&
        valid_from_velidate != undefined &&
        valid_upto_velidate != undefined
      ) {
        let params = `inventory_id=${inventory_id}&duration_type_id=${1}&valid_from=${valid_from_velidate}&valid_upto=${valid_upto_velidate}&access_key=${access_key}`;

        await bookingStore.inventoryPrice(params, (response) => {
          if (response?.data?.status === 1) {
            setInventoryPrice(response?.data?.data);
            // console.log(response?.data?.data)
          } else {
            console.log("error");
          }
        });
      }
    }

    return true;
  };

  const applyCoupon = async (coupon_code) => {
    let startTime = selectSlot && [...selectSlot].shift();
    let endTime = selectSlot[selectSlot.length - 1];
    let start = startTime?.start?.split(":")[0];
    let valid_from = `${selectDate}${" "}${start}:00:00`;
    let end = endTime?.end?.split(":")[0];
    let valid_upto = "";

    if (end <= 9) {
      valid_upto = `${selectDate}${" "}${end}:00:00`;
    } else {
      valid_upto = `${selectDate}${" "}${end}:00:00`;
    }

    let payload;

    if (stateData?.screen === 'direct' || stateData?.screen === 'retry') {
      let startTime = stateData?.selectedItems[0]?.start
      let endTime = stateData?.selectedItems[stateData?.selectedItems.length - 1]?.end;
      let start = startTime?.split(":")[0];
      valid_from = `${selectDate}${" "}${start}:00:00`;
      let end = endTime?.split(":")[0];
      valid_upto = `${selectDate}${" "}${end}:00:00`;

      payload = {
        // coupon_code: coupon_code == couponName ? couponName : coupon_code,
        coupon_code: coupon_code,
        inventory_id: stateData?.inventoryId,
        duration_type_id: 1,
        valid_from: valid_from,
        valid_upto: valid_upto,
      };

    } else {
      payload = {
        // coupon_code: coupon_code == couponName ? couponName : coupon_code,
        coupon_code: coupon_code,
        inventory_id: selectedInvItem
          ? selectedInvItem.id
          : campaign.inventory_id,
        duration_type_id: 1,
        valid_from:
          selectDate !== null && selectDate !== undefined && selectDate !== ""
            ? valid_from
            : campaign?.valid_from,
        valid_upto:
          selectDate !== null && selectDate !== undefined && selectDate !== ""
            ? valid_upto
            : campaign?.valid_upto,
      };
    }

    // let payload = {
    //   // coupon_code: coupon_code == couponName ? couponName : coupon_code,
    //   coupon_code: coupon_code,
    //   inventory_id: selectedInvItem
    //     ? selectedInvItem.id
    //     : campaign.inventory_id,
    //   duration_type_id: 1,
    //   valid_from:
    //     selectDate !== null && selectDate !== undefined && selectDate !== ""
    //       ? valid_from
    //       : campaign?.valid_from,
    //   valid_upto:
    //     selectDate !== null && selectDate !== undefined && selectDate !== ""
    //       ? valid_upto
    //       : campaign?.valid_upto,
    // };
    if (validCoupon) {
      coupon_ref.current.value = "";
      notify("First remove previously applied coupon", "danger");
      return;
    } else {
      await bookingStore.applyCoupon(payload, (response) => {
        if (response?.data?.status === 1) {
          if (response?.data?.data?.discount_amount === null) {
            setValidCoupon(false);
            setCouponName("");
            setCoupon("");
            coupon_ref.current.value = "";
            notify("Invalid Coupon code", "danger");
          } else {
            setInventoryPrice(response?.data?.data);
            setValidCoupon(true);
            coupon_ref.current.value = "";
            notify("Coupon code applied successfully");
          }
        } else {
          // console.log(response.response.data.data[0],"====>error");
          coupon_ref.current.value = "";
          notify(response?.response?.data?.data[0], "danger");
          setValidCoupon(false);
        }
      });
    }
  };

  const getSelectdfnbItem = (fnb) => {
    let orderedFnbList = [];
    FNBList.map((item) => {
      if (item.id === fnb.id) {
        let obj = item;
        obj.isselected = true;
        if (obj.quantity) {
          let totalQuantity = obj.quantity + 1;
          obj.quantity = totalQuantity;
          let finalAmount = totalAmount + Number(obj.price);
          setTotalAmount(finalAmount);
        } else {
          obj.quantity = 1;
          let finalAmount = Number(totalAmount) + Number(obj.price);
          setTotalAmount(finalAmount);
        }
        orderedFnbList.push(obj);
      } else {
        orderedFnbList.push(item);
      }
    });
    let arrayOfOrderedFnb = [];
    orderedFnbList?.map((item) => {
      if (item.quantity) {
        arrayOfOrderedFnb.push(item);
      }
    });
    setOrderedFnbList(arrayOfOrderedFnb);
    sessionStorage.setItem("selectedFnbList", JSON.stringify(arrayOfOrderedFnb));
  };

  const decfnbItem = (fnb) => {
    let orderedFnbList = [];
    FNBList.map((item) => {
      if (item.id === fnb.id) {
        let obj = item;

        if (obj.quantity) {
          let totalQuantity = obj.quantity - 1;
          obj.quantity = totalQuantity;
          let finalAmount = totalAmount - Number(obj.price);
          setTotalAmount(finalAmount);
        } else {
          obj.quantity = 0;
          let finalAmount = Number(totalAmount) - Number(obj.price);
          setTotalAmount(finalAmount);
        }
        orderedFnbList.push(obj);
      } else {
        orderedFnbList.push(item);
      }
    });
    let arrayOfOrderedFnb = [];
    orderedFnbList?.map((item) => {
      if (item.quantity) {
        arrayOfOrderedFnb.push(item);
      }
    });
    setOrderedFnbList(arrayOfOrderedFnb);
    sessionStorage.setItem("selectedFnbList", JSON.stringify(arrayOfOrderedFnb));
    // console.log("item", arrayOfOrderedFnb.price)
  };

  const handleCustomerDetail = async (e) => {
    e.preventDefault();
    if (name === "") {
      notify("Please enter name", "danger");
      return;
    }
    if (email === "") {
      notify("Please enter email", "danger");
      return;
    }
    if (mobile === "") {
      notify("Please enter mobile number", "danger");
      return;
    }

    let res = await getCheckAvailability();

    console.log(res);
    if (res === "success") {
      // navigate(`/${process.env.REACT_APP_BASE_FOLDER}/payment/success/${accessKey}`,{state:{orderedFnbList:orderedFnbList, couponDiscount:couponDiscount, totalAmount:totalAmount}})
      proceedToPayment();
    } else {
      notify("These slots are not available", "danger");
      return;
    }
  };

  const proceedToPayment = async () => {
    let tempFnb = [];
    orderedFnbList?.map((item) => {
      let listItem = {
        name: item?.name,
        price: item?.price,
        id: item?.id,
        qty: item?.quantity,
        item_image: item?.image_url,
      };
      tempFnb.push(listItem);
    });

    let parseInvData =
      selectInverntoryItem !== "undefined" &&
      selectInverntoryItem?.length > 0 &&
      JSON.parse(selectInverntoryItem);
    let inventory_id =
      parseInvData.id != null &&
        parseInvData.id != undefined &&
        parseInvData.id != ""
        ? parseInvData.id
        : campaign?.inventory_id;
    let valid_upto = '';
    let valid_from = '';
    if (stateData?.screen === 'direct' || stateData?.screen === 'retry') {
      let startTime = stateData?.selectedItems[0]?.start
      let endTime = stateData?.selectedItems[stateData?.selectedItems.length - 1]?.end;
      let start = startTime?.split(":")[0];
      valid_from = `${selectDate}${" "}${start}:00:00`;
      let end = endTime?.split(":")[0];
      valid_upto = `${selectDate}${" "}${end}:00:00`;
    }
    let payloadData = {
      user_data: {
        name: name,
        email: email,
        mobile: mobile,
      },
      fnb_data: tempFnb,
      booking_data: {
        inventory_id: stateData?.screen === 'direct' || stateData?.screen === 'retry' ? stateData?.inventoryId : inventory_id,
        valid_from: stateData?.screen === 'direct' || stateData?.screen === 'retry' ? valid_from :
          selectDate
            ? `${selectDate} ${startTime.start}`
            : campaign?.valid_from,
        valid_upto: stateData?.screen === 'direct' || stateData?.screen === 'retry' ? valid_upto :
          selectDate
            ? `${selectDate} ${endTime.end}`
            : campaign?.valid_upto,
        coupon_code: applyedCoupon,
      },
      space_id: selectedSpaceItemId,
      amount: Math.round(couponDiscount?.total_amount + totalAmount),
      access_key: accessKey,
      query_params: location?.state?.searchParamsVal,
    };
    await bookingStore.getPaymentLink(payloadData, (response) => {
      if (response?.data?.status === 1) {
        setName("");
        setMobile("");
        setEmail("");
        window.open(response?.data?.data?.redirectURL, "_self");
      } else {
        setName("");
        setMobile("");
        setEmail("");
        console.log("error");
      }
    });
  };

  return (
    <>
      {scrollFlag &&
        window.scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        })}
      <Header accessKey={accessKey} hide={blockHome} queryParams={location?.state?.searchParamsVal} />
      <div className="payment-container">
        <section className="booking-listing-section">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="payment-detail-box">
                  <div className="row">
                    <div className="col-md-6  no-gutters">
                      <div className="payment-content">
                        <div className="banner-tag">
                          <h3 className="banner-tag-text">
                            {stateData?.screen === 'direct' || stateData?.screen === 'retry' ? invName :
                              selectedInvItem?.name
                                ? selectedInvItem.name
                                : campaign.inventory_name}
                          </h3>
                        </div>
                        <img
                          src={
                            stateData?.screen === 'direct' || stateData?.screen === 'retry' ? spaceImage ? spaceImage : NoImage :
                              selectedInvItem?.images !== undefined &&
                                JSON.parse(selectedInvItem?.images)?.length > 0
                                ? JSON.parse(selectedInvItem?.images)[0]
                                : campaign?.images && JSON.parse(campaign?.images)?.length > 0 ? JSON.parse(campaign?.images) : NoImage
                          }
                          alt="Payment Banner"
                          className="payment-banner"
                        />
                        <h3 className="payment-content-heading">
                          {stateData?.screen === 'direct' || stateData?.screen === 'retry' ? spaceName :
                            selectedSpaceItem?.name
                              ? selectedSpaceItem?.name
                              : spaceName}
                        </h3>
                        <p className="payment-content-text">
                          {stateData?.screen === 'direct' || stateData?.screen === 'retry' ? spaceAddress :
                            selectedSpaceItem.address}
                        </p>
                        <div className="payment-date-box">
                          <p className="payment-date-text">
                            {/* {console.log("campaign.valid_from", campaign?.valid_from?.split(" ")[0])} */}
                            {/* {console.log("selectDate3", selectDate3)} */}
                            {selectDate2}
                          </p>
                          {/* <p className="payment-date-text">6:00 pm - 7:30 pm</p> */}
                          <p className="payment-date-text">
                            {stateData?.screen === 'direct' || stateData?.screen === 'retry' ? `${validStartTime} - ${validEndTime}`
                              :
                              startTime.start ? `${startTime.start} - ${endTime.end}` : `${campaign.valid_from?.split(" ")[1]} - ${campaign.valid_upto?.split(" ")[1]}`

                              // startTime.start ||
                              //   campaign.valid_from?.split(" ")[1]}{" "}
                              // -{" "}
                              // {endTime.end || campaign.valid_upto?.split(" ")[1]}
                            }
                          </p>
                          <p className="payment-date-text">
                            {stateData?.screen === 'direct' || stateData?.screen === 'retry' ? `${capacity} Seater ${invName}`
                              :
                              selectedInvItem?.capacity ? `${selectedInvItem?.capacity} Seater ${selectedInvItem?.name}` : `${campaign?.capacity} Seater ${campaign?.inventory_name}`
                              // selectedInvItem?.name
                              //   ? selectedInvItem?.name
                              //   : campaign?.inventory_name} 
                            }
                          </p>
                        </div>
                        <div className="add-fb-setion">
                          <button
                            type="button"
                            className="modal-btn"
                            data-target="#myModal"
                            data-toggle="modal"
                          >
                            Add F&B
                          </button>
                          {/* {orderedFnbList?.length > 0 && */}
                          {/* <a
                            href="#myModal"
                            data-toggle="modal"
                            className="editfb"
                          >
                            <img
                              src={require("../../assets/images/edit.png")}
                              alt="Edit"
                              className="edit-icon"
                              onClick={() => {
                                // getFNBList();
                              }}
                            />
                          </a> */}
                          {/* } */}
                        </div>
                        {orderedFnbList && orderedFnbList?.map((item) => {
                          console.log(item, "<<<<<<<")
                          return (
                            <div className="list-box">
                              <div className="list-box-inner">
                                <p className="list-box-fitem">{item?.name}</p>
                                <p className="list-box-litem">Rs {item?.price * item?.quantity}</p>
                              </div>
                              <div className="list-box-inner">
                                <p className="list-box-sfitem">Qty</p>
                                <p className="list-box-slitem">{item?.quantity}</p>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="billing-detail-box">
                        <p className="billing-detail-heading">
                          Billing Details
                        </p>
                        <div className="coupon-code-box">
                          <div className="row coupon-full-box">
                            <div className="col-md-12 mobileview-dnone">
                              <img
                                src={require("../../assets/images/badge.png")}
                                alt="Location"
                                className="coupon-icon"
                              />
                              <input
                                ref={coupon_ref}
                                accessible={false}
                                type="text"
                                className="form-control coupon-field"
                                onKeyPress={(e) => {
                                  if (e.key === "Enter") {
                                    if (coupon.length > 0) {
                                      applyCoupon(couponName);
                                      setApplyedCoupon(couponName);
                                      e.target.blur();
                                      window.scroll({
                                        top: 0,
                                        left: 0,
                                        behavior: "smooth",
                                      })
                                    } else {
                                      getSelectedSpaceItem(true);
                                      e.target.blur();
                                      window.scroll({
                                        top: 0,
                                        left: 0,
                                        behavior: "smooth",
                                      })
                                    }
                                  }
                                }}
                                onChange={(e) => {
                                  // if (e.target.value.length > 0) {
                                  // !validCoupon && setCouponName(e.target.value)
                                  !validCoupon && setCoupon(e.target.value);
                                  setCouponName(e.target.value);
                                  if (e.target.value.length > 0) {
                                    setaApplycolor("#ea3526")
                                  } else {
                                    setaApplycolor("#404043")
                                  }
                                  // } else {
                                  //   getSelectedSpaceItem();
                                  // }
                                }}
                                placeholder="Apply Coupon Code"
                              />
                            </div>
                            <div className="col-md-12 mobileview-dblock">
                              {couponName.length == 0 &&
                              <img
                                src={require("../../assets/images/badge.png")}
                                alt="Location"
                                className="coupon-icon"
                              />
                            }
                              <input
                                ref={coupon_ref}
                                accessible={false}
                                type="text"
                                className="form-control coupon-field text-center"
                                onKeyPress={(e) => {
                                  if (e.key === "Enter") {
                                    if (coupon.length > 0) {
                                      applyCoupon(couponName);
                                      setApplyedCoupon(couponName);
                                      e.target.blur();
                                      window.scroll({
                                        top: 0,
                                        left: 0,
                                        behavior: "smooth",
                                      })
                                    } else {
                                      getSelectedSpaceItem(true);
                                      e.target.blur();
                                      window.scroll({
                                        top: 0,
                                        left: 0,
                                        behavior: "smooth",
                                      })
                                    }
                                  }
                                }}
                                onChange={(e) => {
                                  // if (e.target.value.length > 0) {
                                  // !validCoupon && setCouponName(e.target.value)
                                  !validCoupon && setCoupon(e.target.value);
                                  setCouponName(e.target.value);
                                  if (e.target.value.length > 0) {
                                    setaApplycolor("#ea3526")
                                  } else {
                                    setaApplycolor("#404043")
                                  }
                                  // } else {
                                  //   getSelectedSpaceItem();
                                  // }
                                }}
                                placeholder="Apply Coupon Code"
                              />
                            </div>
                            <div className="col-md-12 coupon-btn-box">
                              <button
                                type="button"
                                className="coupon-btn"
                                // id="submitButton"
                                style={{ color: applycolor }}
                                onClick={() => {
                                  if (coupon.length > 0) {
                                    applyCoupon(couponName);
                                    setApplyedCoupon(couponName);
                                  } else {
                                    getSelectedSpaceItem(true);
                                  }
                                }}
                              >
                                Apply Coupon
                              </button>
                            </div>
                            {validCoupon && (
                              <div className="col-md-12">
                                <div class="list-box rcoupon">
                                  <div class="list-box-inner">
                                    <p>
                                      <span>
                                        <i class="fa fa-tag"></i>
                                      </span>
                                      {coupon}
                                      <span className="cc-applied">
                                        applied
                                      </span>
                                    </p>
                                  </div>
                                  <div class="list-box-inner">
                                    <a
                                      className="cremove-btn"
                                      onClick={() => {
                                        setValidCoupon(false);
                                        setCoupon("");
                                        notify(
                                          "Coupon removed successfully",
                                          "danger"
                                        );
                                        let campsessiondata =
                                          sessionStorage.getItem("campdata");

                                        if (campsessiondata) {
                                          getInventoryPrice(
                                            "",
                                            "",
                                            JSON.parse(campsessiondata),
                                            "",
                                            ""

                                          );
                                        } else {
                                          getSelectedSpaceItem();
                                        }
                                      }}
                                    >
                                      Remove
                                    </a>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="total-price-box">
                          <div className="total-price-inner">
                            <p className="total-text">Sub Total</p>
                            <p className="text-price">
                              Rs {couponDiscount?.base_amount}
                            </p>
                          </div>
                          {couponDiscount?.tax_break_up?.map((item) => {
                            return (
                              <div className="total-price-inner">
                                <p className="total-text">{item?.name}</p>
                                <p className="text-price">Rs {item?.value}</p>
                              </div>
                            );
                          })}

                          <div className="total-price-inner">
                            <p className="total-text">Discount</p>
                            <p className="text-price">
                              Rs {couponDiscount?.discount_amount}
                            </p>
                          </div>
                          <div className="total-price-inner-big">
                            <p className="total-text-big">Sub Total</p>
                            <p className="text-price-big">
                              Rs {Number(couponDiscount?.total_amount)}/-
                            </p>
                          </div>
                          <div className="total-price-inner">
                            <p className="total-text">{totalAmount !== 0 ? "F&B" : "No F&B Added"}</p>
                            <p className="text-price">{totalAmount !== 0 && totalAmount}</p>
                          </div>
                          <div className="total-price-inner-gbig">
                            <p className="total-text-gbig">Grand Total</p>
                            <p className="text-price-gbig">
                              Rs {Number(couponDiscount?.total_amount) + totalAmount} /-
                            </p>
                          </div>
                          <div className="checkbox-section">
                            <div className="checkbox">
                              <input
                                type="checkbox"
                                className="input-assumpte"
                                id="accept-term"
                                checked={termsAgree}
                                onChange={() => {
                                  setTermsAgree(!termsAgree);
                                }}
                              />
                              <label htmlFor="accept-term"></label>
                              <div className="checkbox-text">
                                I have read and agreed to terms and conditions available on www.awfis.com
                              </div>
                            </div>
                          </div>
                          <div className="payment-btn-box text-center">
                            <button
                              type="button"
                              className={
                                termsAgree
                                  ? "pay-btn"
                                  : "pay-btn disable-pay-btn"
                              }
                              data-toggle="modal"
                              data-target="#proceedModal"
                              disabled={!termsAgree}
                            >
                              Book Now
                            </button>
                          </div>
                          <div className="notes-box">
                            <p className="notes-text">
                              NOTE. These details cannot be updated/changed once
                              booking is completed
                            </p>
                            <p className="notes-text">
                              ** Hi, please note that the booking will hold for
                              15 minutes till payment is done. Post that an
                              email will be sent for booking confirmation!
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <!-- F & B Modal --> */}
        <div className="modal fade" id="myModal">
          <div className="modal-dialog">
            <div className="modal-content">
              {/* <!-- Modal Header --> */}
              <div className="modal-header">
                <h4 className="modal-title">Recommended Add ons</h4>
                <button type="button" className="close" data-dismiss="modal">
                  &times;
                </button>
              </div>

              {/* <!-- Modal body --> */}
              <div className="modal-body">
                <div className="add-filter-box">
                  <div className="form-group add-group flex-2 w-100">
                    <p className="add-filter-pretext">Filter</p>
                    <select
                      className="form-control add-filter-field"
                      id="addFilter"
                      onChange={(e) => {
                        let data = FNBList;
                        setKey(Math.random());
                        if (e.target.value == 0) {
                          let filter = [];
                          data.forEach((element) => {
                            if (element.is_veg == 0) {
                              // console.log(element,"<===nonveg")
                              filter.push(element);

                              // setFNBList(data)
                            }
                          });
                          setFNBListNew(filter);
                        } else if (e.target.value == 1) {
                          let filter = [];

                          data.forEach((element) => {
                            if (element.is_veg == 1) {
                              filter.push(element);
                              // console.log(element,"<===veg")
                            }
                          });
                          setFNBListNew(filter);
                        } else if (e.target.value == 3) {
                          setFNBListNew(data);
                        }
                        // setFNBList(filter)
                        // if (e.target.value !== "") {
                        //   getFNBList(e.target.value);
                        // } else {
                        //   getFNBList();
                        // }
                      }}
                    >
                      <option value={3}>Both Veg/Non Veg</option>
                      <option value={1}>Veg</option>
                      <option value={0}>Non Veg</option>
                    </select>
                  </div>
                  {/* <div className="fnb-btn"> */}
                  {/* <button>Add</button> */}
                  {/* if (coupon.length > 0) {
                                    applyCoupon(coupon);
                                  } else {
                                    getSelectedSpaceItem(true);
                                  } */}
                  {/*   */}
                </div>
                <div className="add-listing-box" key={key}>
                  {FNBListNew.map((item, index) => {
                    // {console.log("item", item);}
                    return (
                      <FNBListView
                        item={item}
                        orderedFnbList={orderedFnbList}
                        addFnb={getSelectdfnbItem}
                        decFnb={decfnbItem}
                      />
                    );
                  })}
                </div>
              </div>

              {/* <!-- Modal footer --> */}
            </div>
          </div>
        </div>

        {/* <!-- Customer Detail Modal --> */}
        <div className="modal fade" id="proceedModal">
          <div className="modal-dialog login">
            <div className="modal-content">
              {/* <!-- Modal Header --> */}
              <div className="modal-header login">
                <button type="button" className="close" data-dismiss="modal">
                  &times;
                </button>
              </div>

              {/* <!-- Modal body --> */}
              <div className="modal-body login">
                <h3 className="login-heading">Log in to continue </h3>
                <form className="login-form">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control login-field"
                      placeholder="Name"
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="email"
                      className="form-control login-field"
                      placeholder="Email Id"
                      value={email}
                      onBlur={(e) => {
                        let checkMail = ValidateEmail(e.target.value);
                        if (!checkMail) {
                          notify("Please enter correct email", "danger");
                          setEmail("");
                        }
                      }}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="tel"
                      className="form-control login-field"
                      placeholder="Mobile no."
                      value={mobile}
                      maxLength={10}
                      pattern="[0-9]*"
                      onBlur={(e) => {
                        if (e.target.value.length === 10) {
                          setMobile(e.target.value);
                        } else {
                          notify(
                            "Mobile number can only be of 10 digits",
                            "danger"
                          );
                          return;
                        }
                      }}
                      onChange={(e) => {
                        if (e.target.validity.valid) {
                          setMobile(e.target.value);
                        } else {
                          notify("Mobile should contain only number", "danger");
                          return;
                        }
                      }}
                    />
                  </div>
                  <button
                    type="submit"
                    onClick={(e) => handleCustomerDetail(e)}
                    // onClick={(e) => navigate(`/${process.env.REACT_APP_BASE_FOLDER}/payment/success/${accessKey}`)}
                    className="login-btn"
                    data-dismiss="modal"
                  >
                    Proceed to payment
                  </button>
                </form>
              </div>

              {/* <!-- Modal footer --> */}
            </div>
          </div>
        </div>

        {/* <!-- Login Modal --> */}
        <div className="modal fade" id="loginModal">
          <div className="modal-dialog login">
            <div className="modal-content">
              {/* <!-- Modal Header --> */}
              <div className="modal-header login">
                <button type="button" className="close" data-dismiss="modal">
                  &times;
                </button>
              </div>

              {/* <!-- Modal body --> */}
              <div className="modal-body login">
                <h3 className="login-heading">Log in</h3>
                <p className="login--sub-heading">
                  Sign in using your registered mobile no.
                </p>
                <p className="login--sub-heading">or email id.</p>
                <form className="login-form">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control login-field"
                      placeholder="Email Id/Mobile no."
                      id="loginmobile"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <img
                      src={require("../../assets/images/eye.png")}
                      alt="Password"
                      className="eye-icon"
                    />
                    <input
                      type="password"
                      className="form-control login-field"
                      placeholder="Password"
                      id="loginpwd"
                    />
                  </div>
                  <button type="submit" className="login-btn">
                    Log in
                  </button>
                  <div className="form-group form-check">
                    <label className="form-check-label">
                      <input className="form-check-input" type="checkbox" />{" "}
                      Remember me
                    </label>
                    <h3 className="accout-text">
                      <a href="#">Forgot Password</a>
                    </h3>
                  </div>
                </form>
                <h3 className="create-text">
                  Don’t have account?{" "}
                  <a
                    data-toggle="modal"
                    data-target="#signupModal"
                    data-dismiss="modal"
                    className="accout-text"
                  >
                    Sign Up
                  </a>
                </h3>
              </div>

              {/* <!-- Modal footer --> */}
            </div>
          </div>
        </div>

        {/* <!-- Signup Modal --> */}
        <div className="modal fade" id="signupModal">
          <div className="modal-dialog login">
            <div className="modal-content">
              {/* <!-- Modal Header --> */}
              <div className="modal-header login">
                <button type="button" className="close" data-dismiss="modal">
                  &times;
                </button>
              </div>

              {/* <!-- Modal body --> */}
              <div className="modal-body login">
                <h3 className="login-heading">Welcome</h3>
                <p className="login--sub-heading">Sign up to continue</p>
                <form className="login-form">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control login-field"
                      placeholder="Name"
                      id="signupname"
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control login-field"
                      placeholder="Email Id/Mobile no."
                      id="signupemail"
                    />
                  </div>
                  <div className="form-group">
                    <img
                      src={require("../../assets/images/eye.png")}
                      alt="Password"
                      className="eye-icon"
                    />
                    <input
                      type="password"
                      className="form-control login-field"
                      placeholder="Password"
                      id="signuppwd"
                    />
                  </div>
                  <button
                    type="submit"
                    className="login-btn"
                    data-toggle="modal"
                    data-target="#otpModal"
                    data-dismiss="modal"
                  >
                    Sign Up
                  </button>
                  <div className="form-group form-check signup">
                    <label className="form-check-label">
                      <input className="form-check-input" type="checkbox" /> I
                      Agree with Privacy and Policy
                    </label>
                    <label className="form-check-label">
                      <input className="form-check-input" type="checkbox" />{" "}
                      Keep me logged In
                    </label>
                  </div>
                </form>
                <h3 className="create-text signup">
                  Already have an account?{" "}
                  <a
                    data-toggle="modal"
                    data-target="#loginModal"
                    data-dismiss="modal"
                    className="accout-text"
                  >
                    Log in
                  </a>
                </h3>
              </div>

              {/* <!-- Modal footer --> */}
            </div>
          </div>
        </div>

        {/* <!-- OTP Modal --> */}
        <div className="modal fade" id="otpModal">
          <div className="modal-dialog login">
            <div className="modal-content">
              {/* <!-- Modal Header --> */}
              <div className="modal-header login">
                <button type="button" className="close" data-dismiss="modal">
                  &times;
                </button>
              </div>

              {/* <!-- Modal body --> */}
              <div className="modal-body login">
                <h3 className="login-heading">Verify</h3>
                <div className="mobile-edit-box">
                  <p className="otp-sub-heading">
                    We have sent OTP on your number ********90
                  </p>
                  <a
                    data-toggle="modal"
                    data-target="#thankyouModal"
                    data-dismiss="modal"
                  >
                    <img
                      src={require("../../assets/images/mob-edit.png")}
                      alt="Edit"
                      className="edit-number-icon"
                    />
                  </a>
                </div>
                <form className="login-form">
                  <div className="form-group otp-form-group">
                    <input
                      type="text"
                      className="form-control otp-field"
                      placeholder=""
                    />
                    <input
                      type="text"
                      className="form-control otp-field"
                      placeholder=""
                    />
                    <input
                      type="text"
                      className="form-control otp-field"
                      placeholder=""
                    />
                    <input
                      type="text"
                      className="form-control otp-field"
                      placeholder=""
                    />
                  </div>
                  <a href="#" className="enter-otp-text">
                    Enter OTP manually
                  </a>
                  <button
                    type="submit"
                    className="login-btn"
                    data-toggle="modal"
                    data-target="#otpverifyModal"
                    data-dismiss="modal"
                  >
                    Submit
                  </button>
                  <div className="form-group form-check signup">
                    <label className="form-check-label">
                      <input className="form-check-input" type="checkbox" /> I
                      Agree with Privacy and Policy
                    </label>
                    <label className="form-check-label">
                      <input className="form-check-input" type="checkbox" />{" "}
                      Keep me logged In
                    </label>
                  </div>
                </form>
              </div>

              {/* <!-- Modal footer --> */}
            </div>
          </div>
        </div>

        {/* <!-- OTP Verify Modal --> */}
        <div className="modal fade" id="otpverifyModal">
          <div className="modal-dialog otpverify">
            <div className="modal-content">
              {/* <!-- Modal body --> */}
              <div className="modal-body verify-otp text-center">
                <img
                  src={require("../../assets/images/verify.png")}
                  alt="OTP Verify"
                  className="verify-icon"
                />
              </div>

              {/* <!-- Modal footer --> */}
            </div>
          </div>
        </div>

        {/* <!-- Thank You Modal --> */}
        <div className="modal fade" id="thankyouModal">
          <div className="modal-dialog thankyou">
            <div className="modal-content">
              {/* <!-- Modal Header --> */}
              <div className="modal-header login">
                <button type="button" className="close" data-dismiss="modal">
                  &times;
                </button>
              </div>

              {/* <!-- Modal body --> */}
              <div className="modal-body thankyou">
                <h3 className="thank-heading">Thank You!</h3>
                <p className="thank-sub-heading">Your Booking is Confirmed</p>
                <p className="thank-sub-text">
                  The booking confirmation will be sent to your registered Email
                  Id/Mobile No.{" "}
                </p>
              </div>

              {/* <!-- Modal footer --> */}
            </div>
          </div>
        </div>

        {/* <!-- Payment Modal --> */}
        <div className="modal fade" id="paymentModal">
          <div className="modal-dialog login">
            <div className="modal-content">
              {/* <!-- Modal Header --> */}
              <div className="modal-header login">
                <button type="button" className="close" data-dismiss="modal">
                  &times;
                </button>
              </div>

              {/* <!-- Modal body --> */}
              <div className="modal-body login">
                <h3 className="login-heading">Log in</h3>
                <p className="login--sub-heading">
                  Sign in using your registered mobile no.
                </p>
                <p className="login--sub-heading">or email id.</p>
                <form className="login-form">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control login-field"
                      placeholder="Email Id/Mobile no."
                      id="email"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <img
                      src={require("../../assets/images/eye.png")}
                      alt="Password"
                      className="eye-icon"
                    />
                    <input
                      type="password"
                      className="form-control login-field"
                      placeholder="Password"
                      id="pwd"
                    />
                  </div>
                  <button type="submit" className="login-btn">
                    Log in
                  </button>
                  <div className="form-group form-check">
                    <label className="form-check-label">
                      <input className="form-check-input" type="checkbox" />{" "}
                      Remember me
                    </label>
                    <h3 className="accout-text">
                      <a href="#">Forgot Password</a>
                    </h3>
                  </div>
                </form>
                <h3 className="create-text">
                  Don’t have account?{" "}
                  <a href="#" className="accout-text">
                    Sign Up
                  </a>
                </h3>
              </div>

              {/* Modal footer  */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Payment;
